import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import Etapas from "../../../Components/CardsPages/Etapas";
import AtendimentoDetalhado from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado";

import {
    AtendimentoPageProvider,
    useAtendimentoPage,
} from "../../../Context/AtendimentoPage";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useUserInfor } from "../../../Context/User";

import "../../../Assets/css/pages/placeholder.css";
import KPIAssistenciaTecnica from "./KPIAssistenciaTecnica";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import ButtonRelatorioManutencao from "./ButtonRelatorioManutencao";
import AgendamentosDoAtendimento from "./AgendamentosDoAtendimento";
import {
    faCalendar,
    faClock,
    faDollarSign,
    faLink,
    faClipboard,
    faWrench,
    faHandPaper,
} from "@fortawesome/free-solid-svg-icons";
import AtendimentosVinculados from "../../../Components/CardsPages/Atendimento/AtendimentosVinculados";
import ApontamentoHoras from "../../../Components/CardsPages/ApontamentoHoras";
import ButtonAtendimentoRecorrente from "./ButtonAtendimentoRecorrente";
import AcoesAssitenciaTecnica from "./AcoesAssistenciaTecnica";
import DadosFinanceiros from "../../../Components/CardsPages/DadosFinanceiros";
import GetFormulariosPorConta from "../../../Components/CardsPages/Formularios";
import CategoriaAtendimentoCaso from "./CategoriaAtendimentoCaso";
import BotaoRelatorioManuntencaoSemSistema from "../BotaoRelatorioManutencaoSemSistema/BotaoRelatorioManutencaoSemSistema";
import BotaoResponderPesquisaDeSatisfacao from "./AcoesAssistenciaTecnica/BotoesAssistenciaTecnica/BotaoResponderPesquisaDeSatisfacao";
import { ETAPA_ASSISTENCIA_TECNICA } from "../../../Constants/AssistenciaTecnica/EtapaTipoCaso";
import ParalisarVisita from "./ParalisarVisita";
import { IAgendamento } from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";

interface IRouteParams {
    IDCaso: string;
}
interface IAssistenciaTecnicaPageProps {
    IDCaso: number;
}

export default function AtendimentoAssistenciaTecnica() {
    const params = useParams<IRouteParams>();
    const idCaso = Number.parseInt(params.IDCaso);

    return (
        <AtendimentoPageProvider ID_CASO={idCaso}>
            <AssistenciaTecnicaPage IDCaso={idCaso} />
        </AtendimentoPageProvider>
    );
}

function AssistenciaTecnicaPage(props: IAssistenciaTecnicaPageProps) {
    const { ID_USUARIO } = useUserInfor().UserInfor;

    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoExtraDetalhado;

    const { UserInfor } = useUserInfor();

    const [dtSla, setDtSla] = useState(Atendimento.DT_SLA);
    const [lstAgendamentos, setlstAgendamentos] = useState<IAgendamento[]>();
    const updatelstAgendamentos = (lst: IAgendamento[]) => {
        setlstAgendamentos(lst);
    };

    const initialTab = useMemo(
        () => ({
            Component: () => (
                <AgendamentosDoAtendimento
                    updatelstAgendamentos={updatelstAgendamentos}
                    Atendimento={Atendimento}
                    idCaso={props.IDCaso}
                />
            ),
            icon: faCalendar,
            key: "#agendamento",
            name: "Agendamentos",
        }),
        [props.IDCaso, Atendimento]
    );

    const extraTabs = useMemo(() => {
        const extraTabs = [
            {
                key: "#casosVinculados",
                name: "Assistências Técnicas",
                icon: faLink,
                Component: () => (
                    <AtendimentosVinculados idCaso={Atendimento.ID_CASO} />
                ),
            },

            {
                key: "#apontamento",
                name: "Apontamento de Horas",
                icon: faClock,
                Component: () => <ApontamentoHoras Atendimento={Atendimento} />,
            },
            {
                key: "#formularios",
                name: "Formularios",
                icon: faClipboard,
                Component: () => (
                    <GetFormulariosPorConta Atendimento={Atendimento} />
                ),
            },
            {
                key: "#paralisarVisitar",
                name: "Paralisar visita",
                icon: faHandPaper,
                Component: () => (
                    <ParalisarVisita setDtSla={setDtSla} dtSla={dtSla} />
                ),
            },
        ];

        if (ID_ORGANIZACAO === emccampMode) {
            extraTabs.push({
                key: "#categoriasAtendimento",
                name: "Categorias de Atendimento",
                icon: faWrench,
                Component: () => (
                    <CategoriaAtendimentoCaso idCaso={Atendimento.ID_CASO} />
                ),
            });
        }

        if (Atendimento.ID_CHAVE_ERP_VENDA && ID_ORGANIZACAO !== emccampMode) {
            extraTabs.push({
                key: "#financeiro",
                name: "Dados Financeiros",
                icon: faDollarSign,
                Component: () => (
                    <div className="card card-custom">
                        <DadosFinanceiros
                            ID_CHAVE_ERP={Atendimento.ID_CHAVE_ERP_VENDA!}
                        />
                    </div>
                ),
            });
        }

        return extraTabs;
    }, [Atendimento, ID_ORGANIZACAO, dtSla]);

    return (
        <>
            {Atendimento ? (
                <>
                    <div className="col-12 mb-5">
                        <Etapas
                            ID_CATEGORIA={0}
                            ID_ETAPA={Atendimento.ID_ETAPA_TIPO_CASO}
                            finalizado={!!Atendimento.DT_FIM}
                        />
                    </div>
                    {
                        <AtendimentoDetalhado
                            IDCaso={props.IDCaso}
                            Atendimento={Atendimento}
                            inicialTab={initialTab}
                            extraTabs={extraTabs}
                            buttons={
                                <>
                                    {
                                        <>
                                            <div className="d-flex align-items-center mb-1">
                                                {lstAgendamentos &&
                                                lstAgendamentos!.length > 0 ? (
                                                    <ButtonRelatorioManutencao
                                                        {...Atendimento}
                                                        DS_CATEGORIA_ATENDIMENTO_COMP={
                                                            Atendimento.DS_CATEGORIA_ATENDIMENTO_COMP ??
                                                            ""
                                                        }
                                                    />
                                                ) : (
                                                    <></>
                                                )}
                                                {ID_ORGANIZACAO ===
                                                emccampMode ? (
                                                    <BotaoRelatorioManuntencaoSemSistema
                                                        {...Atendimento}
                                                        DS_CATEGORIA_ATENDIMENTO_COMP={
                                                            Atendimento.DS_CATEGORIA_ATENDIMENTO_COMP ??
                                                            ""
                                                        }
                                                    />
                                                ) : null}
                                                {ID_ORGANIZACAO ===
                                                    emccampMode &&
                                                Atendimento?.NR_ETAPA ===
                                                    ETAPA_ASSISTENCIA_TECNICA
                                                        .DUVIDA_TECNICA
                                                        .CD_ETAPA ? (
                                                    <BotaoResponderPesquisaDeSatisfacao
                                                        tpPesquisa="AssistenciaTec"
                                                        setShow={setShow}
                                                        setModal={setModal}
                                                    />
                                                ) : null}

                                                {!Atendimento.FL_CASO_RECORRENTE && (
                                                    <ButtonAtendimentoRecorrente
                                                        ID_CASO={
                                                            Atendimento.ID_CASO
                                                        }
                                                        setModal={setModal}
                                                        setShow={setShow}
                                                        ID_ETAPA_TIPO_CASO={
                                                            Atendimento.ID_ETAPA_TIPO_CASO
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </>
                                    }
                                </>
                            }
                            KPICard={() => (
                                <KPIAssistenciaTecnica
                                    DS_CATEGORIA_ATENDIMENTO_COMP={
                                        Atendimento.DS_CATEGORIA_ATENDIMENTO_COMP
                                    }
                                    DT_SLA={dtSla}
                                    FL_GARANTIA={Atendimento.FL_GARANTIA}
                                    DS_TIPO_RECORRENCIA={
                                        Atendimento.DS_TIPO_RECORRENCIA
                                    }
                                    COMODOS={Atendimento.COMODOS}
                                    FL_CASO_PARALIZADO={
                                        Atendimento.FL_CASO_PARALIZADO
                                    }
                                />
                            )}
                            adicionalComponent={
                                !AtendimentoPage.bloquearInteracoes &&
                                Atendimento.ID_USUARIO_RESPONSAVEL ===
                                    UserInfor.ID_USUARIO &&
                                AtendimentoPage.Atendimento
                                    ?.ID_USUARIO_RESPONSAVEL === ID_USUARIO ? (
                                    <AcoesAssitenciaTecnica
                                        emccampMode={emccampMode}
                                    />
                                ) : (
                                    ""
                                )
                            }
                            emccampMode={emccampMode}
                            ID_ORGANIZACAO={ID_ORGANIZACAO}
                        />
                    }
                </>
            ) : (
                <div className="text-muted text-center">
                    Atendimento não encontrado
                </div>
            )}
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
